import { userService } from "../_services";
import { router } from "../_helpers";

const user =
  JSON.parse(localStorage.getItem("user")) ||
  JSON.parse(sessionStorage.getItem("user"));
const remember = JSON.parse(localStorage.getItem("remember"));
const initialState = user
  ? { status: { loggedIn: true }, user, userInfo: {} }
  : remember
  ? {
      status: {},
      user: null,
      userInfo: {},
      userNameToRemember: remember.userNameToRemember
    }
  : { status: {}, user: null, userInfo: {} };
const state = Object.assign({}, initialState);
export const authentication = {
  namespaced: true,
  state: state,
  getters: {
    user: state => state.user,
    userNameToRemember: state => state.userNameToRemember || "",
    userInfo: state => state.userInfo || ""
  },
  actions: {
    async login({ dispatch, commit }, payload) {
      commit("loginRequest", payload.username);

      userService.login(payload).then(
        user => {
          commit("loginSuccess", user);

          userService.getCurrentUserInfo(payload).then(userInfo => {
            commit("userInfoSuccess", userInfo);
          });
          dispatch("getBaseData");

          router.push("/home");
        },
        error => {
          commit("loginFailure", error);
          dispatch("alert/error", error, { root: true });
          commit("logout");
          router.push("/");
        }
      );
    },

    async adlogin({ dispatch, commit }, payload) {
      var getTokenFromUriOrPopup = function() {
        var matchResult =
          window && window.location && window.location.hash
            ? window.location.hash.match(/^#\?token=(.*)$/)
            : [];
        if (matchResult && matchResult.length == 2) {
          var token = matchResult[1];
          return new Promise(function(resolve) {
            var decoded = atob(token.split(".")[1]);
            var obj = { id_token: decoded, accessToken: token };
            resolve(obj);
          });
        }

        return payload.ad.loginPopup().then(() => payload.ad.getToken());
      };

      getTokenFromUriOrPopup().then(
        tokenResponse => {
          commit("loginSuccess", tokenResponse);
          /* eslint-disable no-console */
          console.log(tokenResponse);
          /* eslint-enable no-console */
          var token = tokenResponse.accessToken || tokenResponse.idToken;
          if (
            !token &&
            tokenResponse.id_token &&
            tokenResponse.id_token.rawToken
          ) {
            token = tokenResponse.id_token.rawToken;
          }
          var obj = {
            access_token: token,
            expires_on: tokenResponse.expiresOn,
            token_type: "Bearer",
            origin: tokenResponse
          };
          localStorage.setItem("user", JSON.stringify(obj));
          dispatch("getBaseData");
          router.push("/home");
        },
        error => {
          commit("loginFailure", error);
          dispatch("alert/error", error, { root: true });
          commit("logout");
          router.push("/");
        }
      );
    },
    getBaseData({ dispatch }) {
      dispatch({ type: "manufacturers/getAllManufacturers" }, { root: true });
      dispatch({ type: "aeds/getFilters" }, { root: true });
      dispatch({ type: "tips/getFilters" }, { root: true });
      dispatch({ type: "aeds/getAddressCategories" }, { root: true });
      dispatch({ type: "aeds/getAdmins" }, { root: true });
      dispatch({ type: "getUserInfo" });
    },
    resetStore({ commit }) {
      commit({ type: "manufacturers/resetState" }, { root: true });
      commit({ type: "aed/resetState" }, { root: true });
      commit({ type: "aeds/resetState" }, { root: true });
      commit({ type: "availability/resetState" }, { root: true });
      commit({ type: "users/resetState" }, { root: true });
    },
    async getUserInfo({ commit }, payload) {
      userService.getCurrentUserInfo(payload).then(userInfo => {
        commit("userInfoSuccess", userInfo);
      });
    },
    logout({ commit, dispatch }) {
      userService.logout();
      router.push("/");
      dispatch("resetStore");
      commit("logout");
    }
  },
  mutations: {
    loginRequest(state, user) {
      state.status = { loggingIn: true };
      state.user = user;
    },
    loginSuccess(state, user) {
      state.status = { loggedIn: true };
      state.user = user;
    },
    loginFailure(state) {
      state.status = {};
      state.user = null;
    },
    logout(state) {
      for (let prop in state) {
        state[prop] = initialState[prop];
      }
      state.userNameToRemember =
        JSON.parse(localStorage.getItem("remember")) &&
        JSON.parse(localStorage.getItem("remember")).userNameToRemember;
    },
    userInfoSuccess(state, userInfo) {
      state.userInfo = userInfo;
    }
  }
};
